import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { capitalizeFirstLetter } from '../../../../utils';

export const generateGroupedConductReport = (reportData) => {
  const doc = new jsPDF();

  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.text('Reporte de Conducta', 14, 15);

  doc.setFontSize(11);
  doc.setFont('helvetica', 'normal');
  doc.text(`Año escolar: ${reportData.schoolYear}`, 14, 22);
  doc.text(`Lapso: ${reportData.lapse}`, 14, 28);

  let currentY = 40;

  Object.entries(reportData.data).forEach(([subject, students]) => {
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text(capitalizeFirstLetter(subject), 14, currentY);
    currentY += 4;

    autoTable(doc, {
      startY: currentY,
      head: [[
        'Estudiante', 'Grado/Año', 'Sección',
        'Cantidad conducta Buena', 'Cantidad conducta Mala'
      ]],
      body: students.map(student => ([
        student.name,
        student.grade,
        student.section,
        student.goodConduct,
        student.badConduct
      ])),
      styles: { fontSize: 9 },
      theme: 'grid',
      headStyles: { fillColor: [200, 200, 200] },
      margin: { left: 14, right: 14 },
      didDrawPage: data => {
        currentY = data.cursor.y + 10;
      }
    });
  });

  doc.save('reporte_conducta.pdf');
};
